import { Col, Row, Divider } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import React, { ReactElement, useEffect, useState } from "react";

const SettlementDetails = ({
  settlementInfo,
  onCloseMethod,
}: {
  settlementInfo: any;
  onCloseMethod: any;
}): ReactElement => {
  const [settlementDetails, setSettlementDetails] = useState(undefined);

  useEffect(() => {
    // BannerDetails();
    setSettlementDetails(settlementInfo);
  }, [settlementInfo]);

  return (
    <React.Fragment>
      <Row gutter={20}>
        <Col span={24}>
          <div className="inner-body-wrapper">
            <div className="inner-body">
              <div className="single">
                <div className="info-name">
                  <span>Delivery Hero</span>
                </div>
                <div className="info-desc">
                  <span>{settlementDetails?.deliveryMan?.name}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Contact Number</span>
                </div>
                <div className="info-desc">
                  <span>
                    {settlementDetails?.deliveryMan?.mobileNumber?.replace(
                      "+88",
                      ""
                    )}
                  </span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Total Amount</span>
                </div>

                <div className="info-desc">
                  <span>&#2547; {settlementDetails?.amount}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Date</span>
                </div>

                <div className="info-desc">
                  <span>
                    {moment(settlementDetails?.createdAt).format("lll")}
                  </span>
                </div>
              </div>

              {/* <div className="single">
                <div className="info-name">
                  <span>Status</span>
                </div>
                <div className="info-desc">
                  <span
                    className={`radius-btn ${settlementDetails?.status?.toLowerCase()}`}
                  >
                    {settlementDetails?.status?.replace("_", " ")}
                  </span>
                </div>
              </div> */}

              <Divider orientation="left">Orders</Divider>

              <div className="single">
                <ol>
                  {settlementDetails?.orderIds?.map((order, i) => (
                    <li key={i}> {order}</li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
SettlementDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default SettlementDetails;
